import { tns } from 'tiny-slider/src/tiny-slider.js';

export function carousel() {
    const slider = tns({
        container: '.js-carousel',
        items: 1,
        nav: true,
        controls: false,
        loop: true,
        autoplay: true,
        autoplayButton: false,
      });
      slider;
}


// WEBPACK FOOTER //
// ./scripts/partials/carousel.js